import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

type PageSystemLayoutProps = {
  children: React.ReactNode;
  pageTitle: string;
  pageSubtitle?: string;
  extraButtons?: React.ReactNode;
  filterBar?: React.ReactElement | null;
};

export const PageSystemLayout: React.FC<PageSystemLayoutProps> = ({
  children,
  pageTitle,
  pageSubtitle,
  extraButtons,
  filterBar,
}) => {
  return (
    <Flex w="100%" direction="column">
      <Flex flex="1" direction="column" p={{ base: 4, lg: 8 }}>
        <Flex direction="column" gap={4} flex={{ base: 1, lg: 'none' }} mb={6}>
          <Flex
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start">
            <Text
              fontSize={32}
              fontFamily="marketingPage"
              fontWeight="bold"
              color="content.title">
              {pageTitle}
            </Text>
            {extraButtons}
          </Flex>
          {pageSubtitle && (
            <Text
              fontSize={16}
              color="content.muted"
              fontFamily="marketingPage">
              {pageSubtitle}
            </Text>
          )}
        </Flex>
        {filterBar && <Box mb={6}>{filterBar}</Box>}
        {children}
      </Flex>
    </Flex>
  );
};
